module.exports = __webpack_public_path__ + "static/img/back.e2d285d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/back.jpg
// module id = 8z0T
// module chunks = 1